<template>
  <div>
    <q-form ref="editForm">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <c-card title="안전 의견 게시판 기본정보" class="cardClassDetailForm">
            <template slot="card-button">
              <q-btn-group outline >
                <c-btn v-if="popupParam.boardId && editable" label="삭제" :editable="editable" icon="delete_forever" @btnClicked="removeData" />
                <c-btn
                  v-if="editable"
                  :url="saveUrl"
                  :isSubmit="isSave"
                  :param="data"
                  :mappingType="mappingType"
                  label="저장"
                  icon="save"
                  @beforeAction="saveData"
                  @btnCallback="saveCallback" />
              </q-btn-group>
            </template>
            <template slot="card-detail">
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <c-text
                  required
                  :editable="editable"
                  label="제목"
                  name="boardTitle"
                  v-model="data.boardTitle">
                </c-text>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
                <c-datepicker
                  required
                  :editable="editable"
                  label="의견게시일"
                  name="boardDate"
                  v-model="data.boardDate">
                </c-datepicker>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
                <c-plant
                  required
                  :editable="editable"
                  type="edit"
                  name="plantCd"
                  v-model="data.plantCd">
                </c-plant>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <c-textarea
                  :editable="editable"
                  :rows="4"
                  label="의견게시내용"
                  name="boardContents"
                  v-model="data.boardContents">
                </c-textarea>
              </div>
            </template>
          </c-card>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <c-card title="관련 파일" class="cardClassDetailForm">
            <template slot="card-detail">
              <div class="col-sm-12 col-md-12 col-lg-12" style="height: 210px">
                <c-upload 
                  :attachInfo="attachInfo"
                  :editable="editable"
                  label="개선/확보관련 파일">
                </c-upload>
              </div>
            </template>
          </c-card>
        </div>
        <div v-show="popupParam.boardId" class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <c-table
            ref="table"
            title="댓글 목록"
            :columns="grid.columns"
            :gridHeight="grid.height"
            :data="data.policyCommentModelList"
            :filtering="false"
            :columnSetting="false"
            :isExcelDown="false"
            :usePaging="false"
            noDataLabel="댓글을 추가하세요."
            :hideBottom="true"
            :editable="editable"
          >
            <template slot="table-button">
              <q-btn-group outline>
                <c-btn
                  v-if="editable"
                  :showLoading="false"
                  label="댓글추가"
                  icon="add"
                  @btnClicked="add"
                />
              </q-btn-group>
            </template>
            <template v-slot:customArea="{ props, col }">
              <template v-if="col.name ==='policyComments'">
                <c-textarea-column
                  v-if="$store.getters.user.userId === props.row.regUserId"
                  :editable="editable"
                  :props="props"
                  :col="col"
                  v-model="props.row['policyComments']"
                />
                <span v-else>
                  {{props.row['policyComments']}}
                </span>
              </template>
              <template v-if="col.name === 'complete'">
                <q-btn
                  class="glossy"
                  round 
                  size="sm"
                  :editable="editable"
                  :disable="$store.getters.user.userId !== props.row.regUserId"
                  color="blue-6"
                  icon="save"
                  @click.stop="saveComment(props.row)" />
                <q-btn
                  class="glossy"
                  round 
                  size="sm"
                  :editable="editable"
                  :disable="$store.getters.user.userId !== props.row.regUserId"
                  color="red"
                  icon="delete"
                  @click.stop="removeComment(props.row)" />
              </template>
            </template>
          </c-table>
        </div>
      </div>
      <c-dialog :param="popupOptions"></c-dialog>
    </q-form>
  </div>
</template>

<script>
import { uid } from 'quasar';
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'saf-opinion-board-detail',
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        boardId: '',
      }),
    },
  },
  data() {
    return {
      attachInfo: {
        isSubmit: '',
        taskClassCd: 'SOB_BOARD',
        taskKey: '',
      },
      grid: {
        columns: [
          {
            name: 'policyComments',
            field: 'policyComments',
            label: '내용',
            align: 'left',
            style: 'width:70%',
            type: 'custom',
            sortable: false,
          },
          {
            name: 'regName',
            field: 'regName',
            label: '작성자/작성일',
            align: 'center',
            style: 'width:20%',
            sortable: false,
          },
          {
            name: 'complete',
            field: 'complete',
            label: '저장/삭제',
            align: 'center',
            style: 'width:10%',
            sortable: false,
            type: "custom",
          },
        ],
        height: "450px",
        data: [],
      },
      saveUrl: transactionConfig.sai.sob.board.insert.url,
      mappingType: 'POST',
      insertUrl: '',
      updateUrl: '',
      deleteUrl: '',
      revlistUrl: '',
      editable: true,
      isSave: false,
      isdelete: false,
      data: {
        boardId: '',
        plantCd: '',
        boardClassCd: 'BC00000001',
        boardDate: '',
        boardContents: '',
        boardTitle: '',
        boardTypeCd: null,
        policyCommentModelList: [],
      },
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        width: '90%',
        top: '10px',
        param: {},
        closeCallback: null,
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      this.data.boardDate = this.$comm.getToday();
      // url setting
      this.detailUrl = selectConfig.sai.sob.board.get.url;
      this.insertUrl = transactionConfig.sai.sob.board.insert.url;
      this.updateUrl = transactionConfig.sai.sob.board.update.url;
      this.deleteUrl = transactionConfig.sai.sob.board.delete.url;
      this.getDetail();
    },
    getDetail() {
      if (this.popupParam.boardId) {
        this.$http.url = this.$format(this.detailUrl, this.popupParam.boardId);
        this.$http.type = 'GET';
        this.$http.request((_result) => {
          this.data = _result.data;
          this.$set(this.attachInfo, 'taskKey', this.popupParam.boardId)
        },);
      } else {
        this.$_.extend(this.data, 'boardClassCd', 'BC00000001')
      }
    },
    saveData() {
      if (this.popupParam.boardId) {
        this.saveUrl = this.updateUrl;
        this.mappingType = 'PUT';
      } else {
        this.saveUrl = this.insertUrl;
        this.mappingType = 'POST';
      }
      this.$refs['editForm'].validate().then(_result => {
        if (_result) {
          window.getApp.$emit('CONFIRM', {
            title: '확인',
            message: '저장하시겠습니까?',
            // TODO : 필요시 추가하세요.
            type: 'info', // success / info / warning / error
            // 확인 callback 함수
            confirmCallback: () => {
              this.data.regUserId = this.$store.getters.user.userId;
              this.data.chgUserId = this.$store.getters.user.userId;

              this.isSave = !this.isSave;
            },
            // 취소 callback 함수
            cancelCallback: () => {
            },
          });
        } else {
          window.getApp.$emit('APP_VALID_ERROR');
        }
      });
    },
    removeData() {
      window.getApp.$emit('CONFIRM', {
        title: '확인',
        message: '삭제하시겠습니까?',
        // TODO : 필요시 추가하세요.
        type: 'warning', // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          this.$http.url = this.$format(this.deleteUrl, this.popupParam.boardId);
          this.$http.type = 'DELETE';
          this.$http.request(() => {
            this.isdelete = !this.isdelete;
            window.getApp.$emit('APP_REQUEST_SUCCESS');
            this.$emit('closePopup');
          },);
        },
        // 취소 callback 함수
        cancelCallback: () => {
        },
      });
    },
    saveCallback(result) {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.popupParam.boardId = result.data
      this.$set(this.attachInfo, 'taskKey', this.popupParam.boardId)
      this.$set(this.attachInfo, 'isSubmit', uid())
      this.getDetail();
    },
    saveComment(data) {
      if (!data.policyComments) {
          window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '필수 입력값을 입력해 주세요. [내용]',
          type: 'warning', // success / info / warning / error
        });
        return;
      }
      window.getApp.$emit('CONFIRM', {
        title: '확인',
        message: '댓글저장하시겠습니까?',
        type: 'warning', // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          if (data.editFlag && data.editFlag === 'C') {
            this.$http.url = transactionConfig.sai.shm.policy.insert.comment.url;
            this.$http.type = 'POST';
          } else {
            this.$http.url = transactionConfig.sai.shm.policy.update.comment.url;
            this.$http.type = 'PUT';
          }
          this.$http.param = data;
          this.$http.request((_result) => {
            data.policyCommentId = _result.data
            this.$refs['table'].selected = [];
            window.getApp.$emit('APP_REQUEST_SUCCESS');
            this.getDetail();
          },);
        },
        // 취소 callback 함수
        cancelCallback: () => {
        },
      });
    },
    removeComment(data) {
      window.getApp.$emit('CONFIRM', {
        title: '확인',
        message: '삭제하시겠습니까?',
        type: 'warning', // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          this.$http.url = this.$format(transactionConfig.sai.shm.policy.delete.comment.url,
            this.popupParam.boardId, data.policyCommentId);
          this.$http.type = 'DELETE';
          this.$http.request(() => {
            this.$refs['table'].selected = [];
            window.getApp.$emit('APP_REQUEST_SUCCESS');
            this.data.policyCommentModelList = this.$_.reject(this.data.policyCommentModelList, {
              policyCommentId: data.policyCommentId,
            });
            this.getDetail();
          },);
        },
        // 취소 callback 함수
        cancelCallback: () => {
        },
      });
    },
    add() {
      this.data.policyCommentModelList.splice(0, 0, {
        boardId: this.popupParam.boardId,
        policyCommentId: uid(),
        policyComments: '',
        regUserId: this.$store.getters.user.userId,
        chgUserId: this.$store.getters.user.userId,
        regName: this.$store.getters.user.userName + ' / ' + this.$comm.getTodayDateTime(),
        editFlag: "C",
      });
    },
  }
};
</script>
